import { normalizeTime } from "../../../services/misc.functions";

export const TrainingCells: React.FC<{ trainings: any; distances: string[] }> = ({ trainings, distances }) => {
  return (
    <>
      {distances.map((distanceKey, idx) => (
        <div key={idx} className="col px-0 d-flex justify-content-center">
          <span className="fw-bold fs-7">
            {normalizeTime(trainings[0]?.[`training_${distanceKey}m`] ?? null) || (
              <span className="text-muted fw-light fs-8">{distanceKey}</span>
            )}
          </span>
        </div>
      ))}
    </>
  );
};
